import { signInWithPopup, signOut as fbSignOut } from 'firebase/auth';
import { auth, microsoftProvider } from './firebase.js';

export async function signInWithMicrosoft(): Promise<void> {
  await signInWithPopup(auth, microsoftProvider());
}

export async function signOut(): Promise<void> {
  await fbSignOut(auth);
}
